<template>
  <div>
    <b-table :items="GET_TRANSACTIONS" :fields="fields">
      <template #head()="data">
        <span>{{ $t(data.label) }}</span>
      </template>
      <template #empty>
        <div class="text-center">
          {{ $t('general.no_records_to_show') }}
        </div>
      </template>

      <template #cell(description)="row">
        <div class="d-flex align-items-center">
          <span v-if="row.item.description">{{ row.item.description }}</span>
          <small v-else class="text-sm">{{
            $t('clients.no_information')
          }}</small>
        </div>
      </template>

      <!-- <template #cell(id)="data">
          <div>
            <span>{{ data.item.id }}</span>
          </div>
        </template> -->

      <template #cell(qr)="{ item }">
        <b-img
          class="w-100 cursor-pointer"
          :src="item.qr"
          @click="showQrCode(item.qr)"
        />
      </template>

      <template #cell(payment_type)="{ item }">
        {{
          payment_type_options.find((el) => el.value === item.payment_type)
            .title[$i18n.locale]
        }}
      </template>

      <template #cell(actions)="{ item }">
        <div class="d-flex justify-content-between">
          <b-button
            v-if="checkPermission('finance-detail')"
            class="px-50"
            size="sm"
            variant="primary"
            @click="$emit('showClick', item.receipt)"
          >
            <feather-icon icon="EyeIcon" size="14" />
          </b-button>
          <b-button
            v-if="checkPermission('finance-download')"
            class="px-50"
            size="sm"
            variant="info"
            @click="downloadClick(item.receipt)"
          >
            <feather-icon icon="DownloadIcon" size="14" />
          </b-button>
          <b-button
            v-if="checkPermission('finance-delete')"
            class="px-50"
            size="sm"
            variant="danger"
            @click="$emit('deleteClick', item.id)"
          >
            <feather-icon icon="TrashIcon" size="14" />
          </b-button>
        </div>
      </template>
    </b-table>

    <template>
      <div class="d-flex justify-content-end flex-wrap">
        <div class="mb-1">
          <b-pagination
            v-model="pagination.page"
            :total-rows="GET_TRANSACTIONS_COUNT"
            :per-page="pagination.page_size"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @change="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { BButton, VBToggle, BTable, BPagination, BImg } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import download from '@/mixins/download'
import checkPermission from '@/mixins/checkPermission'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    BButton,
    BTable,
    BPagination,
    BImg,
    // VueGoodTable,
    // BFormSelect,
  },
  mixins: [download, checkPermission],
  props: {
    params: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        page_size: 10,
        ordering: null,
      },
      paginationRows: 2,
      payment_type_options: [
        {
          title: {
            ru: 'Банк',
            uz: 'Bank',
          },
          value: 'cash',
        },
        {
          title: {
            ru: 'Наличные',
            uz: 'Naqd',
          },
          value: 'noncash',
        },
        {
          title: {
            ru: 'Бартер',
            uz: 'Barter',
          },
          value: 'barter',
        },
      ],
      fields: [
        {
          label: 'contract.qr_code',
          key: 'qr',
          tdClass: 'width-150',
        },
        {
          label: 'finance.date',
          key: 'paid_at',
          formatter(val) {
            return new Date(val).toLocaleString().split(',')[0]
          },
        },
        // {
        //   label: 'finance.cash_box',
        //   key: 'check',
        // },
        {
          label: 'clients.contract',
          key: 'contract',
        },
        {
          label: 'clients.description',
          key: 'description',
        },
        {
          label: 'finance.payment_type',
          key: 'payment_type',
        },
        {
          label: 'finance.summ',
          key: 'amount',
          formatter(val) {
            return new Intl.NumberFormat('ru-Ru', { currency: 'UZS' }).format(
              val,
            )
          },
        },
        {
          label: 'finance.actions',
          key: 'actions',
          tdClass: 'width-150',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('finance', [
      'GET_TRANSACTIONS',
      'getTransactionIncomeType',
      'getTransactionCashbox',
      'GET_TRANSACTIONS_COUNT',
    ]),
  },
  mounted() {
    // this.refresh()
  },
  methods: {
    ...mapActions('finance', ['FETCH_TRANSACTIONS']),
    changePage(value) {
      this.pagination.page = value
      this.$emit('pageChanged', this.pagination)
    },
    showQrCode(url) {
      this.$emit('showQrCode', url)
    },
    downloadClick(url) {
      this.$_downloadBlob(url)
    },
    // changePerPage(page_size) {
    //   this.params.page_size = page_size
    //   this.params.page = 1
    //   this.FETCH_TRANSACTIONS(this.params)
    // },

    // formatFn(date) {
    //   return moment(date)
    //     .locale('ru')
    //     .format('LL')
    // },

    // sortFn(val) {
    //   if (Array.isArray(val)) {
    //     this.params.page = 1
    //     this.params.ordering = val[0].type === 'asc' ? val[0].field : `-${val[0].field}`
    //     this.FETCH_TRANSACTIONS(this.params)
    //     // this.params.ordering = null
    //   }
    // },

    filter(val) {
      console.log('val1', val)
      this.pagination.search = val.search
      this.refresh()
    },
  },
  // eslint-disable-next-line vue/order-in-components
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
